export enum AsyncSearchState {
    None,
    Searching
}